module.exports = __webpack_public_path__ + "media/images/plans/photo_chapel/estimate_3-40888c6b517d83a4c67287bc970b6c84.jpg";